// No browser APIs or JSX: these same components also render during npm run build.
import React from "react";
import { Link, useInRouterContext } from "react-router-dom";
import { guides, overview } from "./content.mjs";
const h = React.createElement;

function NavLink({ href, children, ...props }) {
  const inRouter = useInRouterContext();
  if (inRouter) {
    return h(Link, { to: href, ...props }, children);
  }
  return h("a", { href, ...props }, children);
}

function GuideLinks({ currentPath } = {}) {
  return h("nav", { "aria-label": "Hướng dẫn sử dụng và vận hành nhà trọ", className: "seo-guide-links" },
    guides.filter((guide) => guide.path !== currentPath).map((guide) => h(NavLink, { key: guide.path, href: `${guide.path}/` }, guide.heading)));
}

function ProductOverview() {
  return h("section", { className: "seo-overview", "aria-labelledby": "seo-overview-title" },
    h("h2", { id: "seo-overview-title" }, "Quản lý nhà trọ và cho thuê phòng cùng SP Home"),
    h("div", { className: "seo-overview-grid" }, overview.map((item) => h("article", { key: item.heading },
      h("h3", null, item.heading), h("p", null, item.text)))),
    h("p", null, "Bạn đang xây dựng quy trình vận hành? ", h(NavLink, { href: "/quan-ly-nha-tro/" }, "Xem hướng dẫn quản lý nhà trọ từ nhận khách đến chốt thu chi"), ". Bài viết có bảng theo dõi mẫu và tiêu chí chọn sổ, Excel hay phần mềm."),
    h("h3", null, "Hướng dẫn cho chủ nhà và cộng tác viên"),
    h(GuideLinks));
}

function GuideArticle({ guide }) {
  return h("article", { className: "seo-article" },
    h("nav", { "aria-label": "Đường dẫn trang", className: "seo-breadcrumb" }, h(NavLink, { href: "/" }, "SP Home"), " / ",
      guide.path === "/quan-ly-nha-tro" ? "Quản lý nhà trọ" : h(NavLink, { href: "/quan-ly-nha-tro/" }, "Cẩm nang quản lý nhà trọ")),
    h("header", null, h("p", { className: "seo-eyebrow" }, "Hướng dẫn từ SP Home"), h("h1", null, guide.heading), h("p", { className: "seo-intro" }, guide.intro)),
    guide.showContents && h("nav", { "aria-label": "Mục lục bài viết", className: "seo-contents" },
      h("p", null, h("strong", null, "Trong bài viết")),
      h("ol", null, guide.sections.map((section, index) => h("li", { key: section.heading },
        h("a", { href: `#muc-${index + 1}` }, section.heading.replace(/^\d+\.\s*/, "")))))),
    guide.sections.map((section, index) => h("section", { key: section.heading, id: `muc-${index + 1}`, className: "seo-guide-section" },
      h("h2", null, section.heading),
      (section.paragraphs || []).map((paragraph) => h("p", { key: paragraph }, paragraph)),
      section.table && h("div", { className: "seo-table-scroll", role: "region", "aria-label": section.table.caption, tabIndex: 0 },
        h("table", null,
          h("caption", null, section.table.caption),
          h("thead", null, h("tr", null, section.table.columns.map((column) => h("th", { key: column, scope: "col" }, column)))),
          h("tbody", null, section.table.rows.map((row) => h("tr", { key: row[0] }, row.map((cell, cellIndex) =>
            h(cellIndex === 0 ? "th" : "td", { key: cellIndex, ...(cellIndex === 0 ? { scope: "row" } : {}) }, cell))))))),
      section.items && h(section.ordered ? "ol" : "ul", null, section.items.map((item) => h("li", { key: item }, item))),
      section.links && h("ul", { className: "seo-section-links" }, section.links.map((link) =>
        h("li", { key: link.path }, h(NavLink, { href: link.path }, link.label)))))),
    guide.faqs && h("section", { className: "seo-guide-faq", "aria-labelledby": "seo-faq-title" },
      h("h2", { id: "seo-faq-title" }, "Câu hỏi thường gặp về quản lý nhà trọ"),
      guide.faqs.map((faq) => h("details", { key: faq.question }, h("summary", null, faq.question), h("p", null, faq.answer)))),
    h("aside", { className: "seo-cta" }, h("h2", null, guide.cta), h("p", null, "Mô tả quy mô và nhu cầu của bạn để được hướng dẫn phù hợp."), h(NavLink, { href: "/contact/", className: "seo-cta-link" }, "Liên hệ SP Home")),
    h("h2", null, "Đọc thêm"), h(GuideLinks, { currentPath: guide.path }));
}

export { GuideArticle, ProductOverview };
export default { GuideArticle, ProductOverview };
